/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { forgeClassHelper } from '../utils/classes';
import { useFloating, autoUpdate } from '@floating-ui/react';
import { flip } from '@floating-ui/dom';
import Portal from '../Portal';

const SuggestionsContainer = ({ anchor, containerProps, children }) => {
  const { className, id, role, ...passthroughProps } = containerProps;
  const { refs, update, placement, floatingStyles } = useFloating({
    elements: {
      reference: anchor.input,
    },
    placement: 'bottom-start',
    middleware: [flip()],
    whileElementsMounted: autoUpdate,
  });

  return (
    <div {...passthroughProps}>
      <Portal>
        <div
          ref={refs.setFloating}
          style={{ ...floatingStyles, zIndex: 1001 }}
          data-placement={placement}
          id={id}
          role={role}
        >
          <div className={className}>
            {children && <SuggestionsScroller update={update}>{children}</SuggestionsScroller>}
          </div>
        </div>
      </Portal>
    </div>
  );
};

const classes = forgeClassHelper('typeahead');

const SuggestionsScroller = ({ update, children }) => {
  useEffect(() => {
    update();
  }, [children]);
  return <div {...classes('suggestions-scroller')}>{children}</div>;
};

export default SuggestionsContainer;
